export default __webpack_public_path__ + "static/VisibleLogo-b1fe9fbe98a60b0bb7b6dcfd7b4780c0.svg";